import CustomTooltip from '../../common/CustomTooltip';
import { Markup } from 'interweave';
import React, { Component } from 'react';
import * as Icon from 'react-feather';
import { getAnswers, getResponse, getIdentifier, generateIdentifierIDSysGenerated } from '../../../services/formService';
import { isNullOrEmpty } from '../../common/commonFuncs';

class IdentifierViewer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Widget_ID: 0,
			Widget_Type: 0,
			Identifier_ID: 0,
			Identifier_Name: '',
			Identifier_Format:'',
			Description: '',
			System_Generated: false,
			Response: { Answer_ID: null, Answer_Text: '' },
			SurveyMode: this.props.SurveyMode,
			PrimaryKey: '',
			Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
			loading: true,
			triggerRender: false
		};
	}

	async componentDidMount() {
		//const { data: questionData } = await getQuestion(this.props.Widget_ID);
		const { data: identifierData } = await getIdentifier(this.props.Widget_ID)
		if (identifierData.length > 0) {
			this.setState({
				...this.state,
				Identifier_ID: identifierData[0].Identifier_ID,
				Identifier_Name: identifierData[0].Identifier_Name.replace('</p><p>', '<br />').replace(/(<p[^>]+?>|<p>|<\/p>)/gim, ''),
				Identifier_Format: identifierData[0].Identifier_Format,
				Description: identifierData[0].Identifier_Description,
				System_Generated: identifierData[0].System_Generated,
				PrimaryKey: identifierData[0].Identifier_Format,
				Response_Required: !identifierData[0].System_Generated
			});
		}

		// Load question answers
		const { data: Question_Answers } = await getAnswers(this.state.Identifier_ID);
		Question_Answers.forEach((ans) => (ans.Answer_Text = ans.Answer_Text.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, '')));
		this.setState({ Question_Answers });

		let { data: Response } = await getResponse(this.state.PrimaryKey, this.state.Project_ID, this.state.Identifier_ID);

		if (Response.length > 0) {
			Response = Response[0];
			this.setState({ ...this.state, Response });
		} else {
			if (this.state.Response_Required) {
				this.props.OnUpdate(this.props.Question_Number, {
					Responses: [],
					Response_Required: this.state.Response_Required,
				});
			}
		}

		//Update sys generated id
		if (identifierData.length > 0 && identifierData[0].System_Generated && this.state.SurveyMode) {
			let tempResp = this.state.Response, tempPK = this.props.PrimaryKey, customIdentifierId,
				dataSourceID = identifierData[0].DataSource_ID,
				storedProcedureSelected = identifierData[0].ResultSource_Content,
				institutionElId = document.getElementById('userInst').value,
				institutionCode = institutionElId ? document.getElementsByName('userInst-' + institutionElId)[0].getAttribute('code') : '';
			this.setState({ selectedInst: institutionElId, institutionCode });
			tempResp['Answer_Text'] = tempPK && tempPK.toString()
			if (!this.props.PrimaryKey) {
				customIdentifierId = await generateIdentifierIDSysGenerated({ dataSourceID, storedProcedureSelected, institutionCode });
				customIdentifierId = customIdentifierId.data
				tempResp = this.state.Response
				tempPK = this.state.PrimaryKey + customIdentifierId
				tempResp['Answer_Text'] = customIdentifierId.toString()
			}
			this.setState({ ...this.state, Response: tempResp, Identifier: tempPK })
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: [{ Identifier_ID: (customIdentifierId) ? customIdentifierId : this.props.PrimaryKey, Response: tempResp['Answer_Text'], Identifier_Name: this.state.Identifier_Name}],
				Response_Required: false,
				Identifier: tempPK
			});
		}
		else if (identifierData.length > 0 && identifierData[0].System_Generated && !this.state.SurveyMode) { //show dummies
			let institutionCode = 'UM',
				customIdentifierId = institutionCode + 'XXXX',
				tempResp = this.state.Response
			tempResp['Answer_Text'] = customIdentifierId.toString()
			this.setState({ ...this.state, selectedInst: '1', institutionCode: institutionCode, Response: tempResp })
		}
		else if (identifierData.length > 0 && !identifierData[0].System_Generated) {
			let tempResp = this.state.Response;
			tempResp['Answer_Text'] = this.state.Identifier_Format;
			this.setState({ ...this.state, Response: tempResp });
			//TODO: Add this.props.OnUpdate later for displayng correct PK value on Survey Mode
		}
		this.setState({ loading: false });
	}

	handleSimpleInput(value) {
		const { Response_Required, SurveyMode, Identifier_Format } = this.state;

		if (SurveyMode) {
			let Response = { ...this.state.Response };
			Response.Answer_Text = value;
			this.setState({ error_status: false, Response });

			const responseToSave = {...Response,Answer_Text:`${Identifier_Format}${value}`}
			
			this.props.OnUpdate(this.props.Question_Number, {
				Responses: Response_Required && isNullOrEmpty(value) ? [] : [{ Identifier_ID: this.state.Identifier_ID, Response:responseToSave}],
				Response_Required: Response_Required,
				Identifier:`${Identifier_Format}${value}`,
				isIdentifier:true 
			});
		}
	}

	render() {
		const { loading, Identifier_Name, Widget_ID, Description, Align_Horizontal, Response_Required, Response, System_Generated } = this.state;
		if (loading) return <h1>Loading...</h1>;
		return (
			<div className='card-body'>
				<div className={Align_Horizontal ? 'd-flex justify-content-start' : ''}>
					<div className={Align_Horizontal ? 'col-sm-5' : 'col-sm-12'}>
						<h5 className='card-title'>
							<Markup tagName='span' content={(Response_Required ? '*' : '') + 'Q' + (this.props.Question_Number + 1) + '. ' + Identifier_Name} />
							{Description && (
								<CustomTooltip title={Description} placement='top' className="text-muted pl-1 d-inline">
									<Icon.Info size={20} />
								</CustomTooltip>
							)}

							{System_Generated && (
								<CustomTooltip title='Responded' placement='top' className="pl-1 d-inline">
									<Icon.CheckCircle size={20} color='#00ac69' />
								</CustomTooltip>
							)}
						</h5>
					</div>
					<div className='col'>
						<p>Identifier Format: {System_Generated ? this.state.institutionCode + 'X'.repeat((Response.Answer_Text).length - this.state.institutionCode.length) : Response.Answer_Text}</p>
						<input readOnly={System_Generated ? 'readOnly' : undefined} key={'W' + Widget_ID} placeholder='Enter ID' type='text' className='form-control' value={Response.Answer_Text} onChange={(e) => this.handleSimpleInput(e.target.value)} />
					</div>
				</div>
			</div>
		);
	}
}

export default IdentifierViewer;
